import { addDisplayName, addHandlers, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { UserWithImages } from 'shared/src/api/types'
import cx from 'classnames'
import { addNavigate } from 'shared/src/utils/addNavigate'

import { addNavigateToProfile } from '../../utils/routes'
import { Avatar } from '../Avatar'
import { Button } from '../Button'
import { sansSerifFontFamily } from '../../utils/styles'
import { addShowMenuContext } from '../../utils/menu'
import { EXPLORE_CREATOR_Z_INDEX } from 'utils/zIndex'
import followedCreatorsPlaceholderCreator from '../../assets/followed-creators-placeholder-creator.svg'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: EXPLORE_CREATOR_Z_INDEX,
  },
  placeholder: {
    width: 65,
  },
  username: {
    fontFamily: sansSerifFontFamily,
    fontSize: 12,
    fontWeight: 500,
    color: 'white',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginTop: 3,
  },
})

interface Props {
  creator?: UserWithImages
  textColor?: string
  className?: string
}

export const ExploreCreator: FC<Props> = flowMax(
  addDisplayName('ExploreCreator'),
  addNavigate,
  addNavigateToProfile,
  addShowMenuContext,
  addHandlers({
    onClick:
      ({ navigate, navigateToProfile, creator, setShowMenu }) =>
      () => {
        setShowMenu(false)
        if (creator) {
          navigateToProfile(creator)
        } else {
          navigate('/')
        }
      },
  }),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ creator, onClick, textColor, className, classes }) => (
    <Button onClick={onClick} className={cx(classes.container, className)}>
      {creator ? (
        <Avatar creator={creator} height={64} />
      ) : (
        <img
          src={followedCreatorsPlaceholderCreator}
          alt=""
          className={cx(classes.placeholder)}
        />
      )}
      <div
        className={classes.username}
        style={textColor ? { color: textColor } : {}}
      >
        {creator?.username}
      </div>
    </Button>
  )
)
